import { uploadingFilesStorage } from '$logic/persist-uploads/storage'
import { UploadingFile } from './types'

export async function getUploadingFile(id?: string) {
  if (!id) return undefined
  const uploadingFile = await uploadingFilesStorage.get(id)
  if (!uploadingFile) return undefined

  return { file: uploadingFile.file, multipart: uploadingFile.multipart }
}

export async function saveUploadingFile(id: string, file: File) {
  const { type, name } = file
  await uploadingFilesStorage.insert({ id, name, type, file })
}

export async function updateUploadingFile(
  id: string,
  file: Partial<UploadingFile>,
) {
  await uploadingFilesStorage.update(id, file)
}

export async function deleteUploadingFile(id: string) {
  await uploadingFilesStorage.delete(id)
}
